module.exports = __webpack_public_path__ + "static/apple-icon-144x144.a5925def.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon/apple-icon-144x144.png
// module id = 546
// module chunks = 168707334958949